import { Toaster as Sonner, type ToasterProps } from "sonner"

import { Icon } from "@/components/ds/Icon"

/**
 * Toast del Design System: navy #16263C, texto blanco de 13px, ícono teal
 * claro y radio 10. Centrado abajo a 24px, 3,2 s.
 *
 * REGLA: nunca un modal para confirmar que algo salió bien — eso es un toast.
 */
const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      position="bottom-center"
      offset={24}
      duration={3200}
      // Se mantiene el botón de cierre: el DS no lo pide, pero quitarlo sería
      // una regresión de accesibilidad para quien lee más lento.
      closeButton
      icons={{
        success: <Icon name="check_circle" size={18} className="text-primary-on-dark" />,
        info: <Icon name="info" size={18} className="text-primary-on-dark" />,
        warning: <Icon name="warning" size={18} className="text-on-dark-warning" />,
        error: <Icon name="error" size={18} className="text-on-dark-danger" />,
        loading: <Icon name="progress_activity" size={18} className="animate-fc-spin text-primary-on-dark" />,
      }}
      toastOptions={{
        classNames: {
          toast:
            "!bg-secondary !text-white !border-transparent !rounded-xl !text-[13px] !shadow-[var(--shadow-toast)] !gap-2.5",
          description: "!text-[12px] !text-white/70",
          actionButton: "!bg-primary !text-primary-foreground !rounded-lg",
          cancelButton: "!bg-white/10 !text-white !rounded-lg",
          closeButton: "!bg-secondary-hover !text-white !border-transparent",
        },
      }}
      style={
        {
          "--normal-bg": "var(--secondary)",
          "--normal-text": "#ffffff",
          "--normal-border": "transparent",
          "--border-radius": "10px",
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
